<template>
  <div class="mod-add-passenger">
    <div style="margin-top: 20px">
      <a-form :form="form" layout="vertical">
        <a-form-item label="旅客姓名" required>
          <a-input
            size="large"
            placeholder="请输入旅客姓名"
            v-decorator="[
              'name',
              {
                rules: [
                  { validator: handleFieldValidate },
                ],
                validateTrigger: 'blur',
              },
            ]"
          />
        </a-form-item>
        <!-- <a-form-item label="凭证类型" required>
          <a-select
            placeholder="请输入旅客的凭证类型"
            @change="idTypeChange"
            v-decorator="[
              'idType',
              {
                rules: [{ validator: handleFieldValidate }],
                validateTrigger: 'change',
              },
            ]"
            size="large"
            :options="licenseOptions"
          ></a-select>
        </a-form-item> -->
        <a-form-item required label="证件号码">
          <a-input
            size="large"
            placeholder="请输入证件号码"
            v-decorator="[
              'certificateNo',
              {
                rules: [{ validator: handleFieldValidate }],
                validateTrigger: 'blur',
              },
            ]"
          />
        </a-form-item>
        <a-form-item required label="客票号码">
           <a-input
            size="large"
            :placeholder="`请输入客票号，格式:${ticketCode}-XXXXXXXXXX`"
            v-decorator="[
              'ticketNo',
              {
                rules: [{ validator: handleFieldValidate }],
                validateTrigger: 'blur',
              },
            ]"
          />
        </a-form-item>
        <a-form-item required label="航班日期">
          <a-date-picker
            value-format="YYYY-MM-DD"
            placeholder="请选择航班日期"
            size="large"
            :disabled-date="disabledDate"
            :locale="locale"
            v-decorator="[
              'flightDate',
              {
                initialValue: moment().format('YYYY-MM-DD'),
                rules: [{ validator: handleFieldValidate }],
                validateTrigger: 'blur',
              },
            ]"
          >
          </a-date-picker>
        </a-form-item>
        <a-form-item label="手机号码" required>
          <a-input
            size="large"
            placeholder="请输入手机号码"
            v-decorator="[
              'phone',
              {
                rules: [{ validator: handleFieldValidate }],
                validateTrigger: 'blur',
              },
            ]"
          />
        </a-form-item>
        <a-form-item class="slider-wrapper">
          <slider-verify
            ref="sliderVerify"
            v-model="sliderValue"
            size="large"
          ></slider-verify>
        </a-form-item>
        <a-form-item class="btn-wrapper">
          <a-button type="primary" size="large" @click="addSubmit"
            >前往选购</a-button
          >
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { validate } from '@/assets/js/validate'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import moment from 'moment'
import getAppInfo from '@/utils/from'
// import { message } from 'ant-design-vue'
export default {
  name: 'add-passenger',
  model: {
    event: 'subbmit'
  },
  components: {},
  data () {
    return {
      licenseOptions: [
        {
          value: 'NI',
          label: '身份证'
        },
        {
          value: 'PP',
          label: '护照'
        },
        {
          value: 'TICKETNO',
          label: '票号'
        }
      ],
      idType: 'NI',
      form: this.$form.createForm(this),
      sliderValue: false,
      airline: window.__MICRO_ROOT__?.airline,
      locale,
      ticketCode: getAppInfo()?.ticketCode
    }
  },
  methods: {
    addSubmit (e) {
      // TODO: 临时取消验证码，方便测试
      // if (!this.sliderValue) {
      //   message.error('请完成滑块验证')
      //   return
      // }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('subbmit', values)
        }
      })
    },
    idTypeChange (value) {
      if (!this.showTypeNotice && value === 'PP') {
        setTimeout(() => {
          this.$modal.warning({
            title: '提示',
            content:
              '尊敬的旅客，由于身份校验功能升级，如输入护照无法提取客票信息进行购买，请输入票号进行购买',
            okText: '确认',
            centered: true
          })
        }, 300)
      }
      this.idType = value
    },
    handleFieldValidate (rule, value, callback) {
      validate(
        'extrapassenger',
        this.form.getFieldsValue(),
        rule.fullField
      ).then(({ valid, errors }) => {
        if (valid) {
          callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    reloadVerify () {
      this.$refs.sliderVerify.reloadVerify()
    },
    disabledDate (current) {
      return (
        current < moment().subtract(2, 'years').subtract(1, 'day') ||
        current > moment().add(2, 'years')
      )
    }
  }
}
</script>

<style lang="less">
.mod-add-passenger {
  .slider-wrapper .l8-slider-verify {
    margin: 0 auto;
    height: 50px;
    max-width: 320px;
  }

  .ant-calendar-picker {
    width: 100%;
  }

  .btn-wrapper {
    text-align: center;
    button {
      height: 50px;
    }
  }
}
</style>
